import { render, staticRenderFns } from "./PendentesERejeitadasModal.vue?vue&type=template&id=36748f62&scoped=true"
import script from "./PendentesERejeitadasModal.vue?vue&type=script&lang=js"
export * from "./PendentesERejeitadasModal.vue?vue&type=script&lang=js"
import style0 from "./PendentesERejeitadasModal.vue?vue&type=style&index=0&id=36748f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36748f62",
  null
  
)

export default component.exports